const STEPS = [
  {
    icon: 'fa-bottle-droplet',
    sanskrit: 'Panchamrit Snan',
    title: 'Sacred Immersion',
    text: 'The gemstone is immersed for 10–20 minutes in a metallic vessel holding unboiled cow’s milk, Ganga jal, tulsi leaves, honey and ghee — dissolving every impurity absorbed on its journey.',
  },
  {
    icon: 'fa-hands-bubbles',
    sanskrit: 'Shuddhi',
    title: 'Purifying Rinse',
    text: 'The stone is lifted from the panchamrit, rinsed in clean water and gently dried with a fresh cloth, leaving it physically and energetically spotless.',
  },
  {
    icon: 'fa-place-of-worship',
    sanskrit: 'Sthapana',
    title: 'Altar Preparation',
    text: 'The purified gem is placed on a decorated altar adorned with fresh flowers, an offering plate and sandalwood incense, invoking an atmosphere of divinity.',
  },
  {
    icon: 'fa-om',
    sanskrit: 'Mantra Jaap',
    title: '108 Sacred Chants',
    text: 'The beej mantra of the gemstone’s ruling planet is recited 108 times, awakening the stone’s dormant prana and sealing the cosmic energy within it.',
  },
]

export default function RitualProcessSection() {
  return (
    <section className="relative py-20 md:py-28 md:px-12 bg-[#140608] text-white overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/4 top-0 w-125 h-125 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.08)_0%,transparent_70%)] blur-3xl"></div>
        <div className="absolute right-0 bottom-0 w-100 h-100 rounded-full bg-[radial-gradient(circle,rgba(122,31,43,0.2)_0%,transparent_70%)] blur-3xl"></div>
      </div>

      <div className="container relative z-10 mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center space-y-3 mb-16">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Step by Step</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-[#FBF3E4]">
            The Vedic Pooja <span className="text-gradient-gold font-bold block">Ritual Process</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-white/50">
            Every gemstone ordered from the Divine Shop passes through this exact vidhi before dispatch.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <div key={step.title} className="group relative rounded-3xl border border-white/10 bg-white/4 p-7 backdrop-blur-sm transition-all duration-300 hover:border-goldPrimary/30 hover:bg-white/6">
              <div className="flex items-center justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-secondary">
                  <i className={`fa-solid ${step.icon} text-lg`}></i>
                </div>
                <span className="font-mono text-3xl font-bold text-white/10 transition-colors group-hover:text-goldPrimary/30">{String(i + 1).padStart(2, '0')}</span>
              </div>
              <p className="mt-6 text-[10px] font-mono uppercase tracking-[0.3em] text-secondary/80">{step.sanskrit}</p>
              <h3 className="mt-1 font-heading text-lg uppercase tracking-wide text-[#FBF3E4] font-semibold">{step.title}</h3>
              <p className="mt-3 text-[13px] leading-relaxed text-white/55">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
